import { useEffect, useState } from 'react'
import { api } from '../../../configs/api'
import { useAuth } from '../../../context/AuthContext'
import toast from 'react-hot-toast'
import FunnelChart from './FunnelChart'
import Card from '../../../components/common/Card'

export type FunnelStepType = {
    id: number
    label: string
    value: number
    count: number
}

const Funnels = () => {
    const { unity } = useAuth()
    const [funnels, setFunnels] = useState<any>(null)

    const getFunnels = async () => {
        if (!unity) return

        try {
            const response = await fetch(`${api}calendar/getFunnels`, {
                method: 'POST',
                body: JSON.stringify({
                    unityID: unity.unityID
                })
            })
            const result = await response.json()
            if (!result.success) {
                toast.error(result.message || 'Não foi possível carregar os funnels!')
                return
            }

            setFunnels(result.list || [])
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getFunnels()
    }, [unity])

    if (!funnels) return <div>Carregando...</div>

    return (
        <div className='grid grid-cols-1 sm:grid-cols-2 gap-4'>
            {funnels.map((funnel: any) => (
                <div key={funnel.id}>
                    <Card>
                        <h2 className='font-bold text-base text-gray-700 dark:text-gray-200'>{funnel.label}</h2>
                        <FunnelChart data={funnel.steps} />
                    </Card>
                </div>
            ))}
        </div>
    )
}

export default Funnels
